import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import AsttButtonDark from "components/ASTTButtonDark/AsttButtonDark";
import CloseIcon from "@mui/icons-material/Close";
import {
  getIdmDetails,
  insertIdmTicket,
  deleteIdmAndFacTicket,
} from "../../../services/userServices";
import moment from "moment";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import AsttButton from "components/AsttButton/AsttButton";
import classes from "./IdmTickets.module.css";
import { useTranslation } from "react-i18next";

const IdmModal = (props) => {
  const { t } = useTranslation(["IdmTicket"]);

  const [idmTickets, setIdmTickets] = useState([]);
  const [idmTicket, setIdmTicketValue] = useState("");
  const [addedTickets, setAddedTickets] = useState([]);
  const [ticketAlreadyExist, setTicketExist] = useState(false);
  const [invalidTicketNumber, setInvalidTicketNumber] = useState(false);
  const [invalidMessage, setInvalidMessage] = useState("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;

    const loadIdmTicketDetails = async () => {
      try {
        await getIdmTicketDetails();
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to get IDM ticket details:", error);
        }
      }
    };

    loadIdmTicketDetails();

    return () => {
      cancelled = true;
    };
  }, [props.classRosterId]);

  const getIdmTicketDetails = async () => {
    const idmDetails = await getIdmDetails(props.classRosterId);
    if (idmDetails.status === true) {
      setIdmTickets(idmDetails.data);
    } else {
    }
  };

  const getTicketDetails = (e) => {
    setInvalidTicketNumber(false);
    setTicketExist(false);
    const filteredTicket = idmTickets.filter(
      (itm) => itm.IDMTicketNumber === idmTicket,
    );
    if (filteredTicket.length === 0) {
      setInvalidTicketNumber(true);
    } else if (
      addedTickets.filter(
        (e) => e.IDMTicketNumber === filteredTicket[0].IDMTicketNumber,
      ).length > 0
    ) {
      setTicketExist(true);
    } else {
      setAddedTickets([...addedTickets, ...filteredTicket]);
    }
  };

  const handleDeleteTicket = useCallback(async (e, ticket) => {
    const deleteTicket = await deleteIdmAndFacTicket(
      ticket.idmTicketNumber,
      props.classRosterId,
      null,
    );
    if (deleteTicket.status === true) {
      const filteredTicket = idmTickets.filter(
        (itm) => itm.idmTicketNumber !== ticket.idmTicketNumber,
      );
      setIdmTickets(filteredTicket);
    }
  });

  const insertTicketDetails = useCallback(async () => {
    setInvalidMessage("");
    if (idmTicket !== "") {
      const insertTicket = await insertIdmTicket(
        idmTicket,
        {
          CreatedBy: localStorage.getItem("User"),
          ClassRosterId: props.classRosterId,
          IDMTicketNumber: idmTicket,
        },
        props.classRosterId,
        true,
      );
      if (insertTicket.status === false) {
        setInvalidMessage(insertTicket.message);
      } else if (insertTicket.status === true) {
        getIdmTicketDetails();
        setIdmTicketValue("");
      }
    } else setInvalidMessage("Please enter valid IDM Ticket Number");
  });

  return (
    <div>
      <Grid className="align-center" container>
        <Grid className="p-10px text-end" item xs={4}>
          {t("IDMTicketNumber")}
        </Grid>
        <Grid item xs={3}>
          <input
            name="ticket number"
            className={"dropdown-css p-rl-10  border-blue"}
            maxLength="300"
            type="text"
            value={idmTicket}
            onChange={(e) => setIdmTicketValue(e.target.value)}
          />
        </Grid>
        <Grid className="p-10px text-start " item xs={3}>
          <AsttButtonDark onClick={(e) => insertTicketDetails(e)}>
            {t("SAVE")}
          </AsttButtonDark>
        </Grid>
        <Grid className="p-10px text-end" item xs={2}>
          <CloseIcon onClick={props.onClose}></CloseIcon>
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="p-10px text-end" item xs={4}></Grid>
        <Grid>
          {invalidMessage.length > 0 && (
            <p className={classes.ticketError}>{invalidMessage}</p>
          )}
          {/* {invalidTicketNumber && (
            <p className={classes.ticketError}>Invalid Ticket Number</p>
          )}
          {ticketAlreadyExist && (
            <p className={classes.ticketError}>Ticket Already Exists</p>
          )} */}
        </Grid>
      </Grid>

      <TableContainer className={classes.idmTicketContainer} component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: "#F0F0F0", color: "black" }}>
                {t("Number")}
              </TableCell>
              <TableCell sx={{ backgroundColor: "#F0F0F0", color: "black" }}>
                {t("Type")}
              </TableCell>
              <TableCell sx={{ backgroundColor: "#F0F0F0", color: "black" }}>
                {t("Created")}
              </TableCell>
              <TableCell sx={{ backgroundColor: "#F0F0F0", color: "black" }}>
                {t("OpenedBy")}
              </TableCell>
              <TableCell sx={{ backgroundColor: "#F0F0F0", color: "black" }}>
                {t("NewClientProgram")}
              </TableCell>
              <TableCell
                sx={{ backgroundColor: "#F0F0F0", color: "black" }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {idmTickets.map((row, i) => (
              <TableRow key={i}>
                <TableCell>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href={`https://asknow.service-now.com/sc_req_item.do?sysparm_query=number%3D${row.idmTicketNumber}`}
                  >
                    {row.idmTicketNumber}
                  </a>
                </TableCell>
                <TableCell>{row.ticketType}</TableCell>
                <TableCell>
                  {row.ticketCreateDate
                    ? moment(row.ticketCreateDate).format("YYYY-MM-DD")
                    : ""}
                </TableCell>
                <TableCell>{row.ticketOpenedBy}</TableCell>
                <TableCell>{row.newClientProgram}</TableCell>
                <TableCell>
                  <AsttButton onClick={(e) => handleDeleteTicket(e, row)}>
                    {t("Delete")}
                  </AsttButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default IdmModal;
